<template>
  <div id="app">
    <router-view/>
    <!-- <button @click="topFunction" id="myBtn" title="Go to top">Top</button> -->
  </div>
</template>
<script>
 window.onscroll = function() {function scrollFunction() {
      var mybutton = document.getElementById("myBtn");
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
    } else {
    mybutton.style.display = "none";
    }
  }};

export default {
  methods: {
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  name:'afcfta-visions'
}
</script>
<style>
#app{
  overflow:hidden;
  font-family: Century Gothic ;
  white-space: pre-wrap !important;
}

/* #myBtn {
  display: none;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  font-size: 18px;
  border: none;
  outline: none;
  background-color: red;
  color: white;
  cursor: pointer;
  padding: 15px;
  border-radius: 4px;
} */

#myBtn:hover {
  background-color: #555;
}
#page-container-red{
    background-color:#ba2428 !important;
}
#page-container-white{
    background-color:#fff !important;
}
.myBtn{
    background-color:#ba2428;
    padding:1em 2em;
    color:#fff;
    text-decoration: none;
    border: 1px solid #ba2428;
    transition: all 0.5s;
}
</style>
